import React from "react";
import { GlobeIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { CheckList } from "../CheckList";
import { heroIncludes } from "../../data/content";
import { CREATOR_PHOTO_URL, MOCKUP_URL, PRICE, REFERENCE_PRICE } from "../../data/site";
export function HeroSection() {
  return <header className="relative overflow-hidden bg-navy text-white" data-id="element-206" data-mp="1xau2qva56eqt">
      <svg className="pointer-events-none absolute inset-x-0 top-24 h-24 w-full text-brand opacity-30" viewBox="0 0 1200 100" preserveAspectRatio="none" aria-hidden="true" data-id="element-207" data-mp="1sag2hzes893c">
        <polyline fill="none" stroke="currentColor" strokeWidth="2" points="0,60 300,60 330,60 345,20 360,95 378,5 395,60 640,60 670,60 685,25 700,92 718,10 735,60 1200,60" data-id="element-208" data-mp="1ikeibipjvatp" />
      </svg>

      <div className="border-b border-white/10 bg-navy-800" data-id="element-209" data-mp="14k3llz1k720m">
        <p className="mx-auto max-w-6xl px-4 py-2.5 text-center text-xs font-bold uppercase tracking-[0.14em] text-gold sm:text-sm" data-id="element-210" data-mp="14klrzohxqwm9">
          Special introductory offer · 89% off today
        </p>
      </div>

      <div className="relative mx-auto max-w-6xl px-4 pb-14 pt-10 sm:pt-14 lg:grid lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-12 lg:pb-20" data-id="element-211" data-mp="36g5pex1gu8oe">
        <div className="text-center lg:text-left" data-id="element-212" data-mp="2wojfr54s0hnr">
          <p className="text-sm font-extrabold uppercase tracking-[0.16em] text-brand-sky" data-id="element-213" data-mp="2wpb2rrkb572f">Hemodynamic Monitoring Blueprint™</p>
          <h1 className="mt-4 text-[2.15rem] font-extrabold leading-[1.08] tracking-tight sm:text-5xl lg:text-[3.6rem]" data-id="element-214" data-mp="3pdqfg7fyvdal">
            Master Essential Hemodynamic Monitoring Concepts in Just{" "}
            <span className="text-gold" data-id="element-215" data-mp="3gd0hoy75bcu8">15 Minutes a Day</span>
          </h1>
          <p className="mt-5 text-lg leading-relaxed text-brand-sky sm:text-xl" data-id="element-216" data-mp="3gf4y2fm8e4be">
            With a structured <strong className="text-white" data-id="element-217" data-mp="200vahnptcjlm">6-volume clinical reference system</strong> designed for ICU nurses and
            critical care professionals.
          </p>

          <div className="mt-6 flex items-center justify-center gap-3 lg:justify-start" data-id="element-218" data-mp="agbvmr029de4">
            <img src={CREATOR_PHOTO_URL} alt="Rachel Bennett" className="h-12 w-12 rounded-full object-cover object-top ring-2 ring-gold" data-id="element-219" data-mp="5jlh483wmput" />
            <p className="text-left text-sm leading-tight" data-id="element-220" data-mp="3sul398tf5y4o">
              Created by <span className="font-bold text-white" data-id="element-221" data-mp="3nw9ul1ev1to1">Rachel Bennett</span>
              <br data-id="element-222" data-mp="3nugnxm48z9g1" />
              <span className="text-brand-sky" data-id="element-223" data-mp="3ixghvb7ee6ox">Critical Care Nursing Educator</span>
            </p>
          </div>
        </div>

        <div className="mt-8 lg:mt-0" data-id="element-224" data-mp="3dxlql6jpnf3c">
          <img src={MOCKUP_URL} alt="The Hemodynamic Monitoring Blueprint: 6 volumes and 5 bonuses" className="mx-auto w-full max-w-[560px] drop-shadow-[0_30px_40px_rgba(0,0,0,0.45)]" data-id="element-225" data-mp="3dyn91w3233v3" />
        </div>
      </div>

      <div className="relative bg-white text-ink" data-id="element-226" data-mp="1855his924zlw">
        <div className="mx-auto max-w-3xl px-4 py-12 sm:py-16" data-id="element-227" data-mp="183km70ex5cmz">
          <p className="text-center text-lg font-medium leading-relaxed text-muted" data-id="element-228" data-mp="2q28vdo1bfdaf">
            Stop jumping between scattered textbooks, confusing monitoring parameters, and disconnected clinical notes. Discover a more
            organized way to study hemodynamic monitoring and strengthen your clinical reasoning through visual references and simulated
            cases.
          </p>

          <div className="mt-8 rounded-3xl bg-canvas p-5 ring-1 ring-line sm:p-8" data-id="element-229" data-mp="2757kxnozskz3">
            <p className="text-center text-base font-extrabold text-navy sm:text-lg" data-id="element-230" data-mp="2c2har4gamyng">6 Premium Volumes + 5 Exclusive Bonuses</p>
            <div className="mt-4 flex items-end justify-center gap-4" data-id="element-231" data-mp="2g3ay9wptqbft">
              <span className="pb-2 text-2xl font-bold text-muted line-through decoration-alert decoration-[3px]" data-id="element-232" data-mp="2l479ywgf31vs">{REFERENCE_PRICE}</span>
              <span className="text-7xl font-extrabold leading-none tracking-tight text-cta sm:text-8xl" data-id="element-233" data-mp="3rjrie3cbpg90">{PRICE}</span>
              <span className="pb-2 text-lg font-bold text-navy" data-id="element-234" data-mp="fjcf5nboyt9">USD</span>
            </div>
            <p className="mt-2 text-center text-sm font-bold uppercase tracking-wider text-muted" data-id="element-235" data-mp="3v41g7t4lejxn">One-time payment</p>

            <div className="mt-7" data-id="element-236" data-mp="7x902srelu95">
              <CtaButton id="first-cta" label="Get the complete Blueprint™ now" data-id="element-237" data-mp="7yad32rzcqti" />
            </div>
            <Countdown data-id="element-238" data-mp="3ukrmm6lqpcp" />

            <div className="mt-8 border-t border-line pt-6" data-id="element-239" data-mp="3ucect6khi0z">
              <CheckList items={heroIncludes} columns data-id="element-240" data-mp="hun5zyfpb0n7" />
            </div>

            <p className="mt-6 flex items-start gap-2 rounded-xl bg-white p-3 text-sm text-muted ring-1 ring-line" data-id="element-241" data-mp="cwlovj1u5bed">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-242" data-mp="rlqazbbr3zrr" />
              <span data-id="element-243" data-mp="mllq793t8ivq">
                <strong className="text-ink" data-id="element-244" data-mp="mn6mb35rw9vp">Automatic currency conversion:</strong> paying from outside the US? Your local currency and
                final amount are shown before payment.
              </span>
            </p>
          </div>

          <p className="mt-5 text-center text-xs leading-relaxed text-muted" data-id="element-245" data-mp="vkqqajv0ska0">
            The 15-minute format refers to a focused educational study session, not a complete clinical assessment or a guarantee of
            clinical competency.
          </p>
        </div>
      </div>
    </header>;
}